var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 110,
    viewBox: "0 0 115 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_752_16215)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.859 109.104C59.1788 109.104 60.2486 108.034 60.2486 106.715C60.2486 105.395 59.1788 104.325 57.859 104.325C56.5393 104.325 55.4694 105.395 55.4694 106.715C55.4694 108.034 56.5393 109.104 57.859 109.104Z",
    stroke: "#05CB67",
    strokeWidth: 1.7913,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6921 5.67481C48.0118 5.67481 49.0817 4.60496 49.0817 3.28522C49.0817 1.96549 48.0118 0.89563 46.6921 0.89563C45.3723 0.89563 44.3025 1.96549 44.3025 3.28522C44.3025 4.60496 45.3723 5.67481 46.6921 5.67481Z",
    stroke: "#05CB67",
    strokeWidth: 1.7913,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5718 41.1068C20.5057 41.1068 21.2628 40.3497 21.2628 39.4158C21.2628 38.4819 20.5057 37.7249 19.5718 37.7249C18.6379 37.7249 17.8808 38.4819 17.8808 39.4158C17.8808 40.3497 18.6379 41.1068 19.5718 41.1068Z",
    fill: "#05CB67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2026 95.6659C44.1365 95.6659 44.8936 94.9088 44.8936 93.9749C44.8936 93.041 44.1365 92.2839 43.2026 92.2839C42.2687 92.2839 41.5117 93.041 41.5117 93.9749C41.5117 94.9088 42.2687 95.6659 43.2026 95.6659Z",
    fill: "#05CB67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.0215 88.3863V93.273",
    stroke: "#05CB67",
    strokeWidth: 1.43304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.4646 90.8297H68.5779",
    stroke: "#05CB67",
    strokeWidth: 1.43304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3802 53.0976V57.9807",
    stroke: "#05CB67",
    strokeWidth: 1.43304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8233 55.5374H12.9366",
    stroke: "#05CB67",
    strokeWidth: 1.43304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0625 13.4848V18.3715",
    stroke: "#05CB67",
    strokeWidth: 1.43304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.506 15.9282H56.6194",
    stroke: "#05CB67",
    strokeWidth: 1.43304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M107.764 65.2032H92.4129V67.9904L85.6418 64.0818L92.4129 60.1696V62.9605H107.764V65.2032Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.721 62.2583H91.9581V59.4675L85.187 63.3761L91.9581 67.2883V64.4974H107.721C108.889 64.4917 110.011 64.9501 110.841 65.7718C111.671 66.5935 112.14 67.7112 112.146 68.879C112.152 70.0467 111.693 71.1689 110.872 71.9986C110.05 72.8284 108.932 73.2977 107.765 73.3034V75.5426C109.526 75.5369 111.213 74.8316 112.455 73.5819C113.696 72.3323 114.391 70.6406 114.385 68.879C114.379 67.1173 113.674 65.4301 112.425 64.1885C111.175 62.9469 109.483 62.2526 107.721 62.2583Z",
    fill: "url(#paint0_linear_752_16215)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M82.8154 75.281H98.1632V72.4938L104.938 76.4024L98.1632 80.3146V77.5237H82.8154V75.281Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.6254 74.5286H82.862C81.7159 74.5025 80.6252 74.0305 79.8217 73.2128C79.0182 72.3952 78.5652 71.2964 78.5591 70.15C78.5531 69.0037 78.9944 67.9001 79.7892 67.074C80.584 66.2479 81.6697 65.7644 82.8154 65.7262V63.4835C81.0799 63.5294 79.4312 64.2526 78.2221 65.4985C77.013 66.7444 76.3395 68.414 76.3456 70.1501C76.3516 71.8863 77.0369 73.5511 78.2547 74.7885C79.4725 76.0258 81.1262 76.7375 82.862 76.7713H98.6254V79.5621L105.407 75.6499L98.6326 71.7378L98.6254 74.5286Z",
    fill: "url(#paint1_linear_752_16215)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5461 107.245C39.619 107.244 27.1523 102.445 17.5604 93.7791C7.96837 85.1129 1.93362 73.1955 0.624764 60.3349C-0.684089 47.4742 2.82609 34.5854 10.4755 24.1645C18.125 13.7436 29.3694 6.53211 42.0312 3.92657",
    stroke: "#05CB67",
    strokeWidth: 0.716519,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.51 1.36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2615 106.117C76.1717 103.371 87.5638 95.8398 95.1466 85.0366",
    stroke: "#05CB67",
    strokeWidth: 0.716519,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.51 1.36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5459 2.86603C66.1857 2.86544 79.2836 8.20491 89.0356 17.7413C98.7876 27.2776 104.419 40.253 104.723 53.8893",
    stroke: "#05CB67",
    strokeWidth: 1.07478,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.152 50.5145L100.907 49.7479L104.673 53.4773L108.116 49.4505L108.932 50.1527L104.737 55.0537L100.152 50.5145Z",
    fill: "#05CB67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4934 26.4144H32.505C31.9516 26.414 31.4035 26.5226 30.8921 26.7342C30.3808 26.9457 29.9162 27.2561 29.5248 27.6474C29.1335 28.0387 28.8232 28.5033 28.6116 29.0147C28.4 29.5261 28.2914 30.0742 28.2919 30.6276V48.082C28.2914 48.6354 28.4 49.1835 28.6116 49.6948C28.8232 50.2062 29.1335 50.6708 29.5248 51.0622C29.9162 51.4535 30.3808 51.7638 30.8921 51.9754C31.4035 52.1869 31.9516 52.2956 32.505 52.2951H52.0696V59.1809L58.9517 52.2951H81.4934C82.0465 52.2951 82.5942 52.1861 83.1051 51.9743C83.6161 51.7626 84.0803 51.4522 84.4713 51.0609C84.8622 50.6696 85.1722 50.2051 85.3835 49.694C85.5949 49.1829 85.7034 48.6351 85.703 48.082V30.6276C85.7034 30.0745 85.5949 29.5267 85.3835 29.0156C85.1722 28.5044 84.8622 28.0399 84.4713 27.6487C84.0803 27.2574 83.6161 26.947 83.1051 26.7352C82.5942 26.5234 82.0465 26.4144 81.4934 26.4144Z",
    fill: "white",
    stroke: "#333333",
    strokeWidth: 0.895649,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.5443 29.4991H34.5469C32.8473 29.4991 31.4695 30.877 31.4695 32.5766V46.1367C31.4695 47.8363 32.8473 49.2142 34.5469 49.2142H79.5443C81.244 49.2142 82.6218 47.8363 82.6218 46.1367V32.5766C82.6218 30.877 81.244 29.4991 79.5443 29.4991Z",
    fill: "url(#paint2_linear_752_16215)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.0694 42.0883C53.5791 42.0883 54.8029 40.8644 54.8029 39.3547C54.8029 37.8451 53.5791 36.6212 52.0694 36.6212C50.5597 36.6212 49.3359 37.8451 49.3359 39.3547C49.3359 40.8644 50.5597 42.0883 52.0694 42.0883Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9928 42.0883C64.5025 42.0883 65.7263 40.8644 65.7263 39.3547C65.7263 37.8451 64.5025 36.6212 62.9928 36.6212C61.4831 36.6212 60.2593 37.8451 60.2593 39.3547C60.2593 40.8644 61.4831 42.0883 62.9928 42.0883Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.9197 42.0883C75.4294 42.0883 76.6532 40.8644 76.6532 39.3547C76.6532 37.8451 75.4294 36.6212 73.9197 36.6212C72.41 36.6212 71.1862 37.8451 71.1862 39.3547C71.1862 40.8644 72.41 42.0883 73.9197 42.0883Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1463 42.0883C42.656 42.0883 43.8798 40.8644 43.8798 39.3547C43.8798 37.8451 42.656 36.6212 41.1463 36.6212C39.6366 36.6212 38.4128 37.8451 38.4128 39.3547C38.4128 40.8644 39.6366 42.0883 41.1463 42.0883Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2868 83.8363H61.6206C62.0532 83.8363 62.4816 83.751 62.8813 83.5853C63.281 83.4197 63.6441 83.1768 63.9499 82.8707C64.2556 82.5646 64.4981 82.2012 64.6634 81.8014C64.8286 81.4015 64.9134 80.973 64.9129 80.5403V66.887C64.9134 66.4544 64.8286 66.0259 64.6634 65.626C64.4981 65.2261 64.2556 64.8627 63.9499 64.5566C63.6441 64.2505 63.281 64.0077 62.8813 63.842C62.4816 63.6763 62.0532 63.5911 61.6206 63.5911H46.2942V58.2172L40.9203 63.5911H23.2904C22.8577 63.5911 22.4293 63.6763 22.0296 63.842C21.6299 64.0077 21.2668 64.2505 20.961 64.5566C20.6553 64.8627 20.4128 65.2261 20.2475 65.626C20.0823 66.0259 19.9975 66.4544 19.9979 66.887V80.5403C19.9975 80.9727 20.0822 81.4009 20.2472 81.8005C20.4122 82.2002 20.6544 82.5634 20.9598 82.8694C21.2652 83.1755 21.6278 83.4184 22.0271 83.5843C22.4264 83.7502 22.8544 83.8358 23.2868 83.8363Z",
    fill: "white",
    stroke: "#333333",
    strokeWidth: 0.895649,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.813 81.4216H60.0084C61.338 81.4216 62.416 80.3437 62.416 79.0141V68.4096C62.416 67.08 61.338 66.0021 60.0084 66.0021H24.813C23.4834 66.0021 22.4055 67.08 22.4055 68.4096V79.0141C22.4055 80.3437 23.4834 81.4216 24.813 81.4216Z",
    fill: "url(#paint3_linear_752_16215)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.3016 75.8543C47.4828 75.8543 48.4404 74.8967 48.4404 73.7155C48.4404 72.5342 47.4828 71.5767 46.3016 71.5767C45.1203 71.5767 44.1628 72.5342 44.1628 73.7155C44.1628 74.8967 45.1203 75.8543 46.3016 75.8543Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.757 75.8543C38.9383 75.8543 39.8958 74.8967 39.8958 73.7155C39.8958 72.5342 38.9383 71.5767 37.757 71.5767C36.5758 71.5767 35.6182 72.5342 35.6182 73.7155C35.6182 74.8967 36.5758 75.8543 37.757 75.8543Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2125 75.8543C30.3937 75.8543 31.3513 74.8967 31.3513 73.7155C31.3513 72.5342 30.3937 71.5767 29.2125 71.5767C28.0313 71.5767 27.0737 72.5342 27.0737 73.7155C27.0737 74.8967 28.0313 75.8543 29.2125 75.8543Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.8461 75.8543C56.0273 75.8543 56.9849 74.8967 56.9849 73.7155C56.9849 72.5342 56.0273 71.5767 54.8461 71.5767C53.6649 71.5767 52.7073 72.5342 52.7073 73.7155C52.7073 74.8967 53.6649 75.8543 54.8461 75.8543Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_752_16215",
    x1: 91.7754,
    y1: 56.7734,
    x2: 110.52,
    y2: 75.5139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B94E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2BB1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_752_16215",
    x1: 62383.6,
    y1: 15615.6,
    x2: 62885.6,
    y2: 14707.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B94E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2BB1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_752_16215",
    x1: 31.4695,
    y1: 39.3549,
    x2: 82.6218,
    y2: 39.3549,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05CB67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#05D166"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05E163"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_752_16215",
    x1: -551767,
    y1: -21479.7,
    x2: -556235,
    y2: -21479.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B94E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2BB1FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_752_16215"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 114.364,
    height: 110,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.f637461c39e86a5e161ee4bee8175002.svg";
export { ForwardRef as ReactComponent };